<script>
  import { onMount } from "svelte"
  import { session, gameId, me } from "../store"
  import Shell from "./Shell.svelte"
  import Count from "./Count.svelte"
  import play from "../lib/play"
  import RoundStatus from "./RoundStatus.svelte"
  import punct from "../lib/punct"

  export let sentence = ""
  let submissions = []
  export let blanks = []
  let winner = { words: [] }
  let votes = {}
  let timo = 0
  let voteCount = 0
  let runnerups = []
  let winners = []
  let paragraphs = [1, 4, 8, 10]
  onMount(() => setTimeout(() => play("epic"), 500))
  $: {
    let fills = []
    let votesBySubmission = {}
    winners = Object.entries($session.votes).map(([i, values]) => {
      const submissions = $session.submissions[i]
      const votesBySubmission = Object.entries(values).reduce(
        (out, [key, val]) => {
          if (out[val]) out[val] += 1
          else out[val] = 1
          return out
        },
        {}
      )
      const votes = Object.entries(votesBySubmission)
        .map(([key, val]) => {
          let inx = 0
          return {
            submission: submissions[key],
            participant: $session.participants[key],
            name: $session.participants[key].name,
            words: fillSentence(
              $session.sentences[i],
              submissions[key].submission
            ),
            votes: val
          }
        })
        .sort((a, b) => {
          if (a.votes > b.votes) return -1
          if (a.votes < b.votes) return 1
          if (+a.submission.stamp.seconds < +b.submission.stamp.seconds)
            return -1
          if (+a.submission.stamp.seconds > +b.submission.stamp.seconds)
            return 1
          if (+a.submission.stamp.nanoseconds < +b.submission.stamp.nanoseconds)
            return -1
          if (+a.submission.stamp.nanoseconds > +b.submission.stamp.nanoseconds)
            return 1
          if (a.submission.submission[0] < b.submission.submission[0]) return -1
          if (a.submission.submission[0] > b.submission.submission[0]) return 1
        })
        .slice(0, 10)
      return votes[0]
    })
  }
  function fillSentence(sentence, fills) {
    let inx = 0
    let matches = sentence.match(punct)
    let parts = sentence
      .replace(new RegExp(`[${matches[0].split("").join("\\")}]$`), "")
      .split(" ")
      .map(content => {
        if (content[0] === "%") {
          inx += 1
          return {
            content: fills
              ? fills[inx - 1]
              : blanks[+content.replace("%blank-", "")],
            type: "input"
          }
        }
        return {
          type: "word",
          content: `${content} `
        }
      })
    parts.push({ type: "word", content: `${matches[0]}` })
    return parts
  }
</script>

<style lang="scss">
  @import "../vars";
  .filled {
    background: l($green, 90%);
    padding: 0.2rem 0.4rem;
    margin: 0 0.3rem 0 0.1rem;
    line-height: 110%;
    height: 2.2rem;
  }
  .content {
    line-height: 200%;
    font-size: 1.2rem;
    @include below(bigphone) {
      font-size: 1rem;
    }
  }
  .br {
    margin-bottom: 2rem;
  }
  h2 {
    font-size: 2rem;
    text-align: center;
    color: $green !important;
    margin-top: 0;
    line-height: 145%;
    @include below(bigphone) {
      font-size: 1.7rem;
    }
  }
  .shell {
    background: $white;
    padding: 5rem;
    margin: 0 -6rem;
    @include below(tablet) {
      margin: 0;
    }
    @include below(bigphone) {
      padding: 2.5rem;
    }
  }
  img {
    width: 2.4rem;
    height: 2.3rem;
    margin-top: 1rem;
    margin-bottom: -1rem;
  }
</style>

<div>
  <h2>
    Aww yea, we did it!
    <br />
    Here's the Dream WDS we created together:
  </h2>
  <div class="shell">
    <div class="content">
      {#each winners as v, i}
        {#each v.words as word}
          {#if word.type === 'input'}
            <span class="filled">{word.content}</span>
          {:else}{word.content}{/if}
        {/each}
        &nbsp;
        {#if paragraphs.includes(i)}
          <div class="br" />
        {/if}
      {/each}
    </div>
    <img src="/images/globe.png" />
  </div>
</div>
